import actions from '../../actionTypes';

export default payload => {
  return {
    type: actions.READ_TOKEN_ERROR,
    error: true,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/readTokenError.js